// No "use client" needed; these are plain data exports.
export const TEMPLATE_CATALOG = [
  {
    id: "admissions",
    label: "College Admissions",
    description: "Universal header → Subject → Dear …",
    subjectPrefix: "Letter of Recommendation for",
    greeting: ({ form }) =>
      `Dear ${form.header_greeting?.trim() || "Admissions Committee"},`,
  },
  {
    id: "professional",
    label: "Professional / Employer",
    description:
      "Universal header → Recipient block → Subject → Dear {salutation}, …",
    subjectPrefix: "Letter of Recommendation for",
    greeting: ({ form }) =>
      `Dear ${form.recipient_salutation?.trim() || form.header_greeting?.trim() || "Hiring Manager"},`,
  },
  {
    id: "scholarship",
    label: "Scholarship Committee",
    description: "Universal header → Subject → Dear …",
    subjectPrefix: "Letter of Recommendation for",
    greeting: ({ form }) =>
      `Dear ${form.header_greeting?.trim() || "Scholarship Committee"},`,
  },
  {
    id: "generic",
    label: "Generic (To Whom It May Concern)",
    description: "Universal header → Subject → To Whom It May Concern, …",
    subjectPrefix: "Letter of Recommendation for",
    greeting: () => "To Whom It May Concern,",
  },
];
